import { SET_SELECTED_DASHBOARD_TILES } from './actionTypes';
import { SelectedReport } from '../../modules/dashboard/models';

export const setSelectedDashboardTiles = (selectedOptions: SelectedReport[]) => {
    return {
        type: SET_SELECTED_DASHBOARD_TILES,
        selectedOptions
    };
};